/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetTrackedEmailTypesDictionary$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getTrackedEmailTypesDictionaryRequest = createAction<PayloadData<void>>('EMAIL_DICTIONARY__GET_TRACKED_EMAIL_TYPES_DICTIONARY__REQUEST');
export const getTrackedEmailTypesDictionarySuccess = createAction<PayloadData<Array<DictionaryItem>>>('EMAIL_DICTIONARY__GET_TRACKED_EMAIL_TYPES_DICTIONARY__SUCCESS');
export const getTrackedEmailTypesDictionaryFailure = createAction<PayloadData<Error, void, true>>('EMAIL_DICTIONARY__GET_TRACKED_EMAIL_TYPES_DICTIONARY__FAILURE');

export const getTrackedEmailTypesDictionaryActions = [
    getTrackedEmailTypesDictionaryRequest,
    getTrackedEmailTypesDictionarySuccess,
    getTrackedEmailTypesDictionaryFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getTrackedEmailTypesDictionary = (config?: GetTrackedEmailTypesDictionary$Config) => {
    return {
        CALL_API: {
            types: getTrackedEmailTypesDictionaryActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/tracked-email-types`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

